import React from 'react'
import { Button, Grid, Paper, Typography, Dialog } from '@mui/material'
import { FailedPopIcon } from '../../res/icons'
import CloseIcon from '@mui/icons-material/Close';

const AccPresentPopup = ({ handleClose, errorMessage }) => {
  return (
    <Dialog 
      open={true} 
      onClose={handleClose}
      PaperProps={{
        style: {
          minWidth: '400px',
          minHeight: '300px',
          maxWidth: '500px',
          width: 'auto',
          borderRadius: '12px'
        }
      }}
    >
      <Grid 
        container 
        direction="column" 
        style={{ 
          padding: '2rem',
          height: '100%',
          minHeight: '300px'
        }}
      >
        {/* Close Icon */}
        <Grid item style={{ alignSelf: 'flex-end' }}>
          <CloseIcon 
            style={{
              cursor: 'pointer',
              color: '#666',
              fontSize: '24px'
            }} 
            onClick={handleClose}
          />
        </Grid>

        {/* Icon */}
        <Grid 
          item 
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '1rem'
          }}
        >
          <FailedPopIcon style={{ fontSize: '60px' }}/>
        </Grid>

        {/* Error Title */}
        <Grid 
          item 
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '2rem'
          }}
        >
          <Typography 
            style={{
              fontWeight: 'bold',
              fontSize: '24px',
              color: '#333'
            }}
          >
            OOPS!!
          </Typography>
        </Grid>

        {/* Error Message */}
        <Grid 
          item 
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
            padding: '1rem 2rem'
          }}
        >
          <Typography 
            color='textSecondary' 
            style={{
              fontSize: '16px',
              textAlign: 'center',
              lineHeight: '1.5',
              maxWidth: '400px'
            }}
          >
            {errorMessage || 'An error occurred while processing your request.'}
          </Typography>
        </Grid>

        {/* OK Button */}
        <Grid 
          item 
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 'auto',
            marginBottom: '1rem'
          }}
        >
          <Button 
            style={{
              color: 'white',
              backgroundColor: '#185ABD',
              padding: '8px 32px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '16px',
              minWidth: '120px',
              '&:hover': {
                backgroundColor: '#1348A3'
              }
            }}  
            onClick={handleClose}
          >
            OK
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default AccPresentPopup